import { deepEqualShallow } from '#pplx/frontend/aether/primitives/BoxPrimitive/deepEqualShallow.js';
const DEEP_COMPARE_KEYS = new Set(['padding', 'margin', 'rounded', 'display', 'gap']);
export function areBoxPropsEqual(prev, next) {
    const prevKeys = Object.keys(prev);
    const nextKeys = Object.keys(next);
    if (prevKeys.length !== nextKeys.length)
        return false;
    for (const key of prevKeys) {
        if (DEEP_COMPARE_KEYS.has(key)) {
            if (!deepEqualShallow(prev[key], next[key]))
                return false;
        }
        else if (prev[key] !== next[key]) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=areBoxPropsEqual.js.map